import React from "react";
import {useTranslation} from "react-i18next";

import MDTypography from "../../../materialDashboard/components/MDTypography";
import MDButton from "../../../materialDashboard/components/MDButton";
import MDLoadingButton from "../../../components/MDLoadingButton";

import Stack from "@mui/material/Stack";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Icon from "@mui/material/Icon";



const MultipleEditToolbar = ({multipleEditing, toggleMultipleEditing, updatesCount, deletesCount, onApply, onCancel, loading}) => {
    const {t} = useTranslation(["models1"]);
    const hasChanges = updatesCount > 0 || deletesCount > 0;
    return <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{px: 3, py:2}}>
        <FormControlLabel label={t("multipleEditing.label")}
                          labelPlacement="end"
                          control={
                              <Switch checked={multipleEditing}
                                      onChange={toggleMultipleEditing}
                                      inputProps={{'aria-label': 'controlled'}}
                              />
                          }
        />
        {
            multipleEditing && <>
                <Stack direction="row" ml="auto" mr={2} spacing={2}>
                    {updatesCount > 0 && (
                        <MDTypography variant="body2">
                            {t('multipleEditing.changes', {count: updatesCount})}
                        </MDTypography>
                    )}
                    {deletesCount > 0 && (
                        <MDTypography variant="body2" color="error">
                            {t('multipleEditing.deletes', {count: deletesCount})}
                        </MDTypography>
                    )}
                </Stack>
                <MDButton variant="outlined"
                          color="info"
                          size="small"
                          onClick={onCancel}
                          disabled={!hasChanges}
                          sx={{mr: 2}}>
                    {t('multipleEditing.cancel')}
                </MDButton>
                <MDLoadingButton variant="gradient"
                                 color="info"
                                 size="small"
                                 loading={loading}
                                 onClick={onApply}
                                 disabled={!hasChanges}
                                 startIcon={<Icon>save</Icon>}>
                    {t('multipleEditing.submit')}
                </MDLoadingButton>
            </>
        }
    </Stack>
}

export default MultipleEditToolbar;